import firebase from "../modules/firebase";

export async function uploadFile(imageFile, id) {
  const storageRef = firebase.storage().ref("images/categories");
  const uploadTask = await storageRef
    .child(`${id}/${imageFile.name}`)
    .put(imageFile);
  const filePath = await uploadTask.ref.getDownloadURL();
  return [filePath, imageFile.name];
}

export async function deleteFile(path) {
  const storageRef = firebase.storage().ref("images/categories");
  await storageRef.child(path).delete();
}
